// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"88d74caf","955":"408dc3ac"}[chunkId] + ".chunk.css";
};